var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50661 1.33334H11.8199C12.2533 1.33334 12.6399 1.34669 12.9866 1.39335C14.8333 1.60002 15.3333 2.46668 15.3333 4.84001V9.05335C15.3333 11.4267 14.8333 12.2933 12.9866 12.5C12.6399 12.5467 12.2599 12.56 11.8199 12.56H5.50661C5.07328 12.56 4.68661 12.5467 4.33995 12.5C2.49328 12.2933 1.99329 11.4267 1.99329 9.05335V4.84001C1.99329 2.46668 2.49328 1.60002 4.33995 1.39335C4.68661 1.34669 5.07328 1.33334 5.50661 1.33334Z",
    stroke: "#0A49A5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71997 5.54668H12.1733",
    stroke: "#0A49A5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15997 9.40666H5.1733H12.18",
    stroke: "#0A49A5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33331 14.6667H12",
    stroke: "#0A49A5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46309 5.53334H5.46908",
    stroke: "#0A49A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66298 5.53334H7.66897",
    stroke: "#0A49A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannel);
export default __webpack_public_path__ + "static/media/channel.00c64e23cca05437d858597e09fdcbf0.svg";
export { ForwardRef as ReactComponent };